var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccesAllowance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5879 4.29097L13.4129 3.10889L5.98508 10.4918L2.58772 7.11665L1.41309 8.29905L5.98537 12.8414L14.5879 4.29097Z",
    fill: "#36F7D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccesAllowance);
export default __webpack_public_path__ + "static/media/succesAllowance.9f5e2652ebb9eaab9511337270dce569.svg";
export { ForwardRef as ReactComponent };